// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const WORK_APR_ST = {
  Criada: 'WORK_APR_ST1',
  Pendente: 'WORK_APR_ST2',
  Aprovada: 'WORK_APR_ST3',
  Reprovada: 'WORK_APR_ST4',
  Inativa: 'WORK_APR_ST5',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    WORK_APR_ST1: 1,
    WORK_APR_ST2: 2,
    WORK_APR_ST3: 3,
    WORK_APR_ST4: 4,
    WORK_APR_ST5: 5
  }
}
